import { c as _c } from "react/compiler-runtime";
import { Heading } from '@petsmart-ui/sparky';
import { BaseTable } from '@/components/BaseTable/BaseTable';
import { type JobDetails } from '@/types';
import { sortJobsByMostRecent } from '@/utils/sortJobsByMostRecent';
import { tableConfig } from './tableConfig';
export type JobDetailsTableProps = Readonly<{
  isJobsLoading: boolean;
  jobDetails: JobDetails[];
}>;
export function JobDetailsTable(t0) {
  const $ = _c(6);
  const {
    isJobsLoading,
    jobDetails
  } = t0;
  let t1;
  if ($[0] !== jobDetails) {
    const recentJobs = sortJobsByMostRecent(jobDetails);
    t1 = recentJobs?.slice(0, 10);
    $[0] = jobDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading tagName="h4" className="sparky-u-margin-top-xxl">Your Bulk Promo Generation Table</Heading>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data || $[4] !== isJobsLoading) {
    t3 = <>{t2}<div className="homepage-table-wrapper"><BaseTable data={data} config={tableConfig} loading={isJobsLoading} caption="Bulk Promo Generation Table" loadingContent="Loading job details..." emptyContent="No job details available." rowKey={_temp} /></div></>;
    $[3] = data;
    $[4] = isJobsLoading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(job) {
  return job.jobId;
}